import fetch from './http'
/**
 * 检测店铺名称是否可用
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
export const getStoreNameIsAvailable = params => {
  return fetch.fetchGet('api/store/seller/v1/shop/storenameisexist', params)
}

/**
 * 查询店铺模板初始化结果
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
export const getStoreInitialResults = params => {
  return fetch.fetchGet('api/store/seller/v1/shop/getinitresult', params)
}
/**
 * 得到可用的店铺链接
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
export const getAvailableStoreLinks = params => {
  return fetch.fetchGet('api/store/seller/v1/shop/getshorturl', params);
};
/**
 * 查询店铺模板初始化结果
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
// export const  getStoreInitialResults = params => {
//   return fetch.fetchGet('api/store/seller/v1/shop/getinitresult', params);
// };